export default __webpack_public_path__ + "static/media/zero_transaction.d63de2dc.png";